import { ICompanyData, ICompanyInfoResponse } from '../interfaces/businessData';
import { TRANSLATION_COLLABORATORS } from '../translations/collaborators';

export const metricsData = (data: ICompanyInfoResponse): ICompanyData => {
  const metrics = data.additionalInfo.metrics
    ? {
        metrics: {
          generation: obtainGenerations(data),
          state: obtainState(data),
          gender: obtainGender(data)
        }
      }
    : {};
  return {
    id: data.id,
    name: data.name,
    locale: data.locale,
    externalPaymentUrl: data.externalPaymentUrl ?? '',
    additionalInfo: metrics,
    clusterType: data.clusterType,
    companyGroup: data.companyGroup,
    countryCode: data.countryCode,
    keyCompany: data.keyCompany,
    planId: data.planId,
    plans: data.plans,
    dateToMigrate: data.dateToMigrate,
    hasMembers: data.hasMembers,
    createdAt: data.createdAt
  };
};

const obtainGenerations = (data: ICompanyInfoResponse) => {
  try {
    return data.additionalInfo.metrics
      ? {
          millennial: data.additionalInfo.metrics.all.generation.millennial,
          centennial: data.additionalInfo.metrics.all.generation.centennial,
          generationX: data.additionalInfo.metrics.all.generation.generation_x,
          silentGeneration: data.additionalInfo.metrics.all.generation.silent_generation,
          babyBoomer: data.additionalInfo.metrics.all.generation.baby_boomer,
          generationAlpha: data.additionalInfo.metrics.all.generation.generation_alpha
        }
      : undefined;
  } catch {
    return undefined;
  }
};

const obtainState = (data: ICompanyInfoResponse) => {
  try {
    return data.additionalInfo.metrics
      ? {
          active: data.additionalInfo.metrics.all.state.active,
          inactive: data.additionalInfo.metrics.all.state.inactive
        }
      : undefined;
  } catch {
    return undefined;
  }
};

const obtainGender = (data: ICompanyInfoResponse) => {
  try {
    return data.additionalInfo.metrics
      ? {
          female: data.additionalInfo.metrics.all.gender.female,
          nonBinary: data.additionalInfo.metrics.all.gender.non_binary,
          male: data.additionalInfo.metrics.all.gender.male
        }
      : undefined;
  } catch {
    return undefined;
  }
};

export const getCollaboratorsTexts = (totalSelected: number) => {
  const isPlural = totalSelected > 1;

  const getKey = (singularKey: string, pluralKey: string) => (isPlural ? pluralKey : singularKey);

  const resendEmailsTitle = getKey(
    TRANSLATION_COLLABORATORS.table.resendEmailModal.title,
    TRANSLATION_COLLABORATORS.table.resendEmailModal.plural.title
  );

  const resendEmailsDescription = getKey(
    TRANSLATION_COLLABORATORS.table.resendEmailModal.description,
    TRANSLATION_COLLABORATORS.table.resendEmailModal.plural.description
  );

  const deleteModalTitle = getKey(
    TRANSLATION_COLLABORATORS.table.deleteModal.title,
    TRANSLATION_COLLABORATORS.table.deleteModal.plural.title
  );

  const deleteModalDescription = getKey(
    TRANSLATION_COLLABORATORS.table.deleteModal.description,
    TRANSLATION_COLLABORATORS.table.deleteModal.plural.description
  );

  return {
    resendEmailsTitle,
    resendEmailsDescription,
    deleteModalTitle,
    deleteModalDescription
  };
};
